import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { TabsModule } from 'primeng/tabs';
import { LucideAngularModule } from 'lucide-angular';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';

interface HelpTab {
  labelKey: string;
  route: string;
  icon: string;
}

@Component({
  selector: 'app-help-page',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    PageHeaderComponent,
    TabsModule,
    RouterOutlet,
    RouterLink,
    LucideAngularModule,
  ],
  templateUrl: './help-page.component.html',
})
export class HelpPageComponent {
  private router = inject(Router);

  tabs: HelpTab[] = [
    {
      labelKey: 'help.tabs.onboarding',
      route: 'onboarding',
      icon: 'graduation-cap',
    },
    {
      labelKey: 'help.tabs.support',
      route: 'support',
      icon: 'message-circle',
    },
    {
      labelKey: 'help.tabs.resources',
      route: 'resources',
      icon: 'layers',
    },
    {
      labelKey: 'help.tabs.howItWorks',
      route: 'how-it-works',
      icon: 'book-open',
    },
  ];

  /** Falls back to the journey: it is the first tab and what `/home/help` redirects to. */
  get currentTab(): string {
    const url = this.router.url;
    if (url.includes('support')) return 'support';
    if (url.includes('resources')) return 'resources';
    if (url.includes('how-it-works')) return 'how-it-works';
    return 'onboarding';
  }
}
